import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useForm} from "react-hook-form";
import clsx from "clsx";
import {Button, Card, CardActions, CardContent, CardHeader, Grid, Tooltip, Typography} from "@mui/material";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {addNoteToDiario} from "../../../../../services/AnagraficaServices";
import {setOpenSnackbar} from "../../../../../services/AppServices";

const NoteSection = ({idSoggetto}) => {
	const classes = BaseStyle();
	const {register, handleSubmit, errors} = useForm({mode: "onChange"});
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);

	const onSubmit = useCallback((data) => {
		setSubmit(true)
		addNoteToDiario({
			...data, soggetto: idSoggetto,
		}, idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.dispatch])

	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingAddNote && anagraficaContext.state.errorAddNote === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Note aggiunte con successo", appContext.dispatch);
		} else if (submit && !anagraficaContext.state.loadingAddNote && anagraficaContext.state.errorAddNote !== "") {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorAddNote, appContext.dispatch);
		}
	}, [submit, anagraficaContext.state.loadingAddNote, anagraficaContext.state.errorAddNote, appContext.dispatch])

	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Aggiungi note</b></Typography>}
					subheader={"Inserisci delle note nel diario dell'anagrafica"}
				/>
				<CardContent style={{flexGrow: 1}}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<CustomMultiText
									inputRef={register({required: true})}
									name={"text"}
									label={"Note diario"}
									autoFocus={false}
									error={errors["text"]}
									rows={16}
								/>
							</Grid>
						</Grid>
					</form>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Aggiungi note al diario dell'anagrafica"}>
						<Button className={classes.roundButton} size={"small"} variant={"contained"} disableElevation
						        style={{borderRadius: 24}} onClick={handleSubmit(onSubmit)}
						        color={"primary"}>
							<b>Aggiungi</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
}

export default React.memo(NoteSection);
